const InfoCard = ({ children }) => {
  return (
    <div className="bg-lightGray rounded-md md:py-1 md:px-3 lg:p-2 lg:col-span-3 md:mb-2 md:max-w-[200px]">
      {children}
    </div>
  );
};

export default InfoCard;
